import { render } from "./ThePatientVideoCallOverlay.vue?vue&type=template&id=04daef9a&scoped=true&ts=true"
import script from "./ThePatientVideoCallOverlay.vue?vue&type=script&lang=ts"
export * from "./ThePatientVideoCallOverlay.vue?vue&type=script&lang=ts"

import "./ThePatientVideoCallOverlay.vue?vue&type=style&index=0&id=04daef9a&lang=scss"
import "./ThePatientVideoCallOverlay.vue?vue&type=style&index=1&id=04daef9a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04daef9a"]])

export default __exports__